export const InstructorTranslateKey: { [key: string]: string } = {
    Name: 'Imię',
    Surname: 'Nazwisko',
    Password: 'Hasło',
    Email: 'Adres mailowy',
    Pesel: 'PESEL',
    DateOfBirth: 'Data narodzin',
    MotherName: 'Imię matki',
    MotherSurname: 'Nazwisko matki',
    FatherName: 'Imię ojca',
    Street: 'Ulica',
    BuildingNumber: 'Numer domu',
    FlatNumber: 'Numer lokalu',
    PostCode: 'Kod pocztowy',
    City: 'Miejscowość'
}